module.exports = __webpack_public_path__ + "media/images/user/favicons/icon-16x16-1376b548391b97bd03f3fa57359a5adb.png";